import './App.css';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Application from './Application';
import Home from './pages/Home';
import VehicleSelect from './pages/VehSelect';
import VehicleOperation from './pages/VehOperation';
import { SelectedVehicleProvider } from './context/vehicle.context';
import { UserProvider } from './context/user.context';

function App() {
  return (
    <UserProvider>
      <SelectedVehicleProvider>
        <Routes>
          <Route path="/" element={<Application />}>
            <Route index element={<Home />} />
            <Route path={"vehicle-select"} key={2} element={<VehicleSelect key={2} />} />
            <Route path={"vehicle-operation"} key={3} element={<VehicleOperation key={3} />} />
          </Route>
        </Routes>
      </SelectedVehicleProvider>
    </UserProvider>
  );
}

export default App;
